function increaseQuantity(e) {
  var itemId = this.getAttribute("data-item-id");
  var input = document.querySelector(
    '.quantity-input[data-item-id="' + itemId + '"]',
  );
  input.value = parseInt(input.value) + 1;
  updateCartItem(itemId, parseInt(input.value));
}

function decreaseQuantity(e) {
  var itemId = this.getAttribute("data-item-id");
  var input = document.querySelector(
    '.quantity-input[data-item-id="' + itemId + '"]',
  );
  if (parseInt(input.value) >= 1) {
    input.value = parseInt(input.value) - 1;
    updateCartItem(itemId, parseInt(input.value));
  }
}
function removeItem(e) {
  var itemId = this.getAttribute("data-item-id");
  var input = document.querySelector(
    '.quantity-input[data-item-id="' + itemId + '"]',
  );
  if (parseInt(input.value) >= 1) {
    input.value = 0;
    updateCartItem(itemId, parseInt(input.value));
  }
}

async function addToCart(formData) {
  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      body: formData,
    });
    const data = await response.json();

    console.log("Producto agregado al carrito:", data);

    reloadCartSnippet(data, true);
    document.getElementById("cart-drawer").classList.add("open");
  } catch (error) {
    console.error("Error al agregar el producto al carrito:", error);
  }
}

function updateCartItem(line, quantity) {
  // Prepare the data to be sent in the request
  const data = {
    updates: {
      [line]: quantity,
    },
  };

  // Make an AJAX request to update the cart
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then(async (updatedCart) => {
      reloadCartSnippet(updatedCart);
      // Optionally, you can refresh the cart UI or perform other actions
    })
    .catch((error) => {
      console.error("Error updating cart:", error);
    });
}

function reloadCartSnippet(updatedCart, isAdd2Cart = false) {
  const badge = document.getElementById("cart-drawer-count");
  if (isAdd2Cart) {
    badge.classList.add("visible");
    try {
      let value = parseInt(badge.dataset.headerCartCount) + 1;
      if (isNaN(value)) value = 1;
      badge.setAttribute("data-header-cart-count", value);
    } catch (e) {
      console.error("Error al incrementar el contador del carrito", e);
    }
  } else {
    if (updatedCart.item_count === 0) {
      badge.classList.remove("visible");
    } else {
      badge.classList.add("visible");
      badge.innerHTML = updatedCart.item_count;
      badge.setAttribute("data-header-cart-count", updatedCart.item_count);
    }
  }
  // Hacer una solicitud AJAX para obtener el snippet actualizado
  fetch(location.href + "?section_id=cart-drawer&time=" + new Date().getTime())
    .then((response) => response.text())
    .then((html) => {
      const cartSnippet = document.getElementById("cart-drawer");
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(html, "text/html");
      const newCartDrawer = newDocument.getElementById("cart-drawer");
      if (newCartDrawer) {
        removeListeners();
        cartSnippet.innerHTML = newCartDrawer.innerHTML;
        connectEventListeners();
      }
    })
    .catch((error) => {
      console.error("Error al re-renderizar el snippet:", error);
    });
}

async function add2CartCustom(event, form) {
  event.preventDefault();
  const formData = new FormData(form);
  for (var pair of formData.entries()) {
    console.log(pair[0] + ", " + pair[1]);
  }
  await addToCart(formData);
}

function getWidth() {
  const elements = document.getElementsByClassName("css-upsell-item");
  let elementWidth = 200;
  if (elements.length > 0) elementWidth = elements.item(0).offsetWidth;
  return elementWidth + 10;
}

function moveXScrollRight(e) {
  e.preventDefault();
  const element = document.getElementById("css-products-upsell-container");
  const elementWidth = getWidth();
  element.scrollLeft += elementWidth;
}

function moveXScrollLeft(e) {
  e.preventDefault();
  const element = document.getElementById("css-products-upsell-container");
  const elementWidth = getWidth();
  element.scrollLeft -= elementWidth;
}

function removeListeners() {
  const close = document.getElementById("close-cart-drawer");
  if (close)
    close.removeEventListener("click", function () {
      document.getElementById("cart-drawer").classList.remove("open");
    });
  document.querySelectorAll(".increase-quantity").forEach(function (button) {
    if (button) button.removeEventListener("click", increaseQuantity);
  });
  document.querySelectorAll(".decrease-quantity").forEach(function (button) {
    if (button) button.removeEventListener("click", decreaseQuantity);
  });
  document.querySelectorAll(".css-button-remove").forEach(function (button) {
    if (button) button.removeEventListener("click", removeItem);
  });

  const right = document.getElementById("css-arrow-right");
  if (right) right.removeEventListener("click", moveXScrollRight);
  const left = document.getElementById("css-arrow-left");
  if (left) left.removeEventListener("click", moveXScrollLeft);

  const forms = document.getElementsByClassName("css-form-add2cart");
  for (let i = 0; i < forms.length; i++) {
    forms[i].removeEventListener("submit", (event) => {
      event.preventDefault();
      add2CartCustom(event, forms[i]);
    });
  }
}

function connectEventListeners() {
  const close = document.getElementById("close-cart-drawer");
  if (close)
    close.addEventListener("click", function () {
      removeListeners();
      document.getElementById("cart-drawer").classList.remove("open");
    });
  document.querySelectorAll(".increase-quantity").forEach(function (button) {
    if (button) button.addEventListener("click", increaseQuantity);
  });
  document.querySelectorAll(".decrease-quantity").forEach(function (button) {
    if (button) button.addEventListener("click", decreaseQuantity);
  });
  document.querySelectorAll(".css-button-remove").forEach(function (button) {
    if (button) button.addEventListener("click", removeItem);
  });
  const right = document.getElementById("css-arrow-right");
  if (right) right.addEventListener("click", moveXScrollRight);
  const left = document.getElementById("css-arrow-left");
  if (left) left.addEventListener("click", moveXScrollLeft);

  const forms = document.getElementsByClassName("css-form-add2cart");
  for (let i = 0; i < forms.length; i++) {
    forms[i].addEventListener("submit", (event) => {
      event.preventDefault();
      add2CartCustom(event, forms[i]);
    });
  }
}

document.addEventListener("DOMContentLoaded", async () => {
  const cartDrawer = document.getElementById("cart-drawer");

  const forms = document.querySelectorAll("form[action='/cart/add']");
  forms.forEach((form) => {
    form.addEventListener(
      "submit",
      async (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        const submitButton = form.querySelector(
          "[type='submit'], .add2cart-btn",
        );
        if (submitButton) submitButton.disabled = true;
        try {
          await add2CartCustom(event, form);
          if (cartDrawer) {
            cartDrawer.classList.add("open");
            connectEventListeners();
          }
        } finally {
          setTimeout(() => {
            if (submitButton) submitButton.disabled = false;
          }, 1000); // Delay to allow UI updates
        }
      },
      { capture: true },
    );
  });

  cartDrawer.addEventListener("click", (event) => {
    const cartDrawerContent = document.getElementById(
      "cart-drawer-content-wrapper",
    );
    if (cartDrawer && cartDrawerContent) {
      if (
        cartDrawer.classList.contains("open") &&
        !cartDrawerContent.contains(event.target)
      ) {
        removeListeners();
        cartDrawer.classList.remove("open");
      }
    }
  });

  const openLink = document.getElementById("open-cart-drawer");
  if (openLink)
    openLink.addEventListener("click", function (e) {
      e.preventDefault();
      if (location.pathname === "/cart") return;
      document.getElementById("cart-drawer").classList.add("open");
      connectEventListeners();
    });
});
